import { IconButton } from '@mui/material';
import { GridColDef, getGridStringOperators } from '@mui/x-data-grid-pro';

import { IcDotSpread } from '@/assets/images';
import { excludeValues, sortStrings } from '@/components/DataGrid/utils';
import { IMasterAddress } from '@/models/master.address';
import { getAddressLocation } from '@/services';
import { generateUniqueId, getUpdatedLabel } from '@/utils';

const uniqueId = (): Partial<GridColDef> => ({
  field: 'uniqueId',
  renderCell: (params) => {
    const { uniqueId: uId } = params.row;
    return generateUniqueId('ADR', uId);
  },
  filterOperators: getGridStringOperators().filter(
    excludeValues(['isNotEmpty', 'isEmpty', 'isAnyOf']),
  ),
  valueGetter: (_, row) => generateUniqueId('ADR', row.uniqueId),
});

const addressLabel = (): Partial<GridColDef> => ({
  renderCell: (params) => {
    return getAddressLocation(params.row) || '-';
  },
  filterOperators: getGridStringOperators().filter(
    excludeValues(['isAnyOf', 'isNotEmpty', 'isEmpty']),
  ),
  valueGetter: (_, row) => row.normalized || '',
  sortComparator: sortStrings,
});

const subAddress = (): Partial<GridColDef> => ({
  field: 'subAddress',
  renderCell: (params) => params.row.subAddress || '-',
  filterOperators: getGridStringOperators().filter(
    excludeValues(['isAnyOf', 'isNotEmpty', 'isEmpty']),
  ),
  sortComparator: sortStrings,
});

const addressNotesCount = (): Partial<GridColDef> => ({
  renderCell: (params) => params.row.addressNotesCount || 0,
  filterable: false,
  sortable: false,
});

const lastUpdated = (): Partial<GridColDef> => ({
  renderCell: (params) => getUpdatedLabel(params.row?.updatedAt),
  filterable: false,
  sortable: false,
});

const actions = (
  openMenu?: (
    event: React.MouseEvent<HTMLButtonElement>,
    row: IMasterAddress,
  ) => void,
): Partial<GridColDef> => ({
  width: 96,
  sortable: false,
  filterable: false,
  align: 'center',
  headerAlign: 'center',
  disableColumnMenu: true,
  renderCell: (params) => (
    <IconButton
      onClick={(event) => {
        event.stopPropagation();
        openMenu?.(event, params.row);
      }}
    >
      <IcDotSpread />
    </IconButton>
  ),
});

export const masterAddressCols = (
  _navigate?: (path: string) => void,
  _onDelete?: (row: IMasterAddress) => void,
  openMenu?: (
    event: React.MouseEvent<HTMLButtonElement>,
    row: IMasterAddress,
  ) => void,
) => {
  return {
    uniqueId,
    addressLabel,
    subAddress,
    addressNotesCount,
    lastUpdated,
    actions: () => actions(openMenu),
  };
};
